export var HeaderContentOptions;
(function (HeaderContentOptions) {
    HeaderContentOptions[HeaderContentOptions["Navigation"] = 0] = "Navigation";
    HeaderContentOptions[HeaderContentOptions["Breadcrumbs"] = 10] = "Breadcrumbs";
    HeaderContentOptions[HeaderContentOptions["Countdown"] = 20] = "Countdown";
    HeaderContentOptions[HeaderContentOptions["None"] = 30] = "None";
})(HeaderContentOptions || (HeaderContentOptions = {}));
